module.exports = __webpack_public_path__ + "static/professional.5022964c.webp";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/2022/photos/a-propos/professional.webp
// module id = 913
// module chunks = 3